/**
 * Feature Flags Service for Frontend
 *
 * Controls application behavior through environment-based feature flags.
 * All flags default to false for backward compatibility.
 */

const VITE_PREFIX = 'VITE_';

/**
 * Get a feature flag value
 * @param {string} flagName - The name of the feature flag
 * @returns {boolean} The flag value, defaults to false if flag doesn't exist
 */
const getFeatureFlag = (flagName) => {
  const envVariableName = `${VITE_PREFIX}${flagName}`;
  const value = import.meta.env[envVariableName];

  if (value === undefined) {
    console.warn(`Unknown feature flag: ${flagName} (looked for ${envVariableName})`);
    return false;
  }

  return value === 'true';
};

export default getFeatureFlag;
